import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Features, Roles } from "../../components/routing/utils";

import Peripherals from "./page.highorder";

const ProtectedPeripherals = () => (
  <AuthorizedRoute
    requiredRoles={[Roles.ADMIN]}
    component={Peripherals}
    requiredFeatures={[Features.MANAGE_PERIPHERALS]}
  />
);

const peripheralsRoute = (
  <Route path="/manage-peripherals" element={<ProtectedPeripherals />} />
);

export default peripheralsRoute;
